<main class="mat-body" *ngIf="contract">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12" *ngIf="!contract || !contract.isAdvisoryModelGDC()">
                <thr-contract-progress [percent]="80" *ngIf="!canFinalizeContract"></thr-contract-progress>
                <thr-contract-progress [percent]="100" *ngIf="canFinalizeContract"></thr-contract-progress>
            </div>
            <div class="col-12" *ngIf="contract && contract.isAdvisoryModelGDC()">
                <thr-contract-progress-gdc [percent]="80" *ngIf="!canFinalizeContract"></thr-contract-progress-gdc>
                <thr-contract-progress-gdc [percent]="100" *ngIf="canFinalizeContract"></thr-contract-progress-gdc>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'full-data.complete-data'|translate" *ngIf="!user || !user.isAdmin"></h1>
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'full-data.validate-data'|translate" *ngIf="user && user.isAdmin"></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-full-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1" />
                <div class="text-right">
                    <a class="mat-subheading-1 text-blue" mat-button [routerLink]="'/' + MainRoutes.FULL_DATA_LIST">
                        <strong>{{ 'full-data.see-all'|translate }}</strong>
                    </a>
                </div>
            </div>
            <div class="col-12 mb-4">
                <thr-full-data-iban-table [iban]="contract.iban" [isAdmin]="user && user.isAdmin" [isComplete]="contract.isComplete()" [isValidated]="contract.isValidated() || contract.validation.isValid()"></thr-full-data-iban-table>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <mat-accordion class="full-data" [displayMode]="'flat'" [hideToggle]="true">
                    <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" (afterCollapse)="onAccordionChange()" (afterExpand)="onAccordionChange()">
                        <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                            <mat-panel-title>
                                <h2 class="mat-subheading-1 mb-0">{{ 'full-data.account-ownership'|translate }}</h2>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="bg-gray-gradient pt-3 px-3 pb-5">
                            <form #formFullDataAccount="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                                <h3 class="mat-subheading-1 text-blue font-weight-bold mb-4">
                                    {{ 'full-data.provide-certain-documentation'|translate }}
                                </h3>

                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6">
                                        <mat-form-field class="full-width mb-3 mb-sm-4">
                                            <input name="faIban" matInput mask="SS00 0000 0000 00 0000000000" required maxlength="35" iban [placeholder]="'form.account-number'|translate" [(ngModel)]="contract.iban" [disabled]="user && user.isAdmin" #ibanCtrl="ngModel" />
                                            <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="ibanCtrl.hasError('iban')">
                                                {{ 'form.validation.iban'|translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mat-subheading-1 text-blue font-weight-bold">
                                    {{ 'form.documents'|translate }}

                                    <mat-hint class="d-block mat-caption text-blue font-italic">
                                        {{ 'form.documents-help'|translate:{size: 6} }}
                                    </mat-hint>
                                </h3>

                                <ng-template ngFor let-document [ngForOf]="contract.documents" let-i="index">
                                    <div class="mb-3 mb-sm-4">
                                        <thr-file-selector [name]="'faDocument' + i" [label]="document.name" [filename]="document.filename" [canView]="document.id && !document.file" filesize filetype [required]="!document.optional && (!document.id || document.remove)" [disabled]="user && user.isAdmin"
                                            [(ngModel)]="document.file" (view)="onDocumentView(document)" (remove)="onDocumentRemove(document)" #documentCtrl="ngModel"></thr-file-selector>
                                        <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filetype') && !documentCtrl.hasError('required')">
                                            {{ 'form.validation.filetype'|translate }}
                                        </mat-error>
                                        <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filesize') && !documentCtrl.hasError('required')">
                                            {{ 'form.validation.filesize'|translate:{size: 6} }}
                                        </mat-error>
                                        <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('required')">
                                            {{ 'form.validation.required'|translate }}
                                        </mat-error>
                                    </div>
                                </ng-template>

                                <h2 class="text-blue mat-display-1 mt-5 mb-0" [innerHTML]="'form.choose-who-will-provide-correspondence'|translate"></h2>
                                <hr class="mt-1" />
                                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-4">{{ 'form.communications-info'|translate }}</h2>
                                <h3 class="mat-subheading-1 text-blue font-weight-bold my-3">{{ 'form.participants'|translate }}</h3>

                                <thr-full-data-appropriateness-table [contract]="contract" [participants]="participants" [isDisabled]="user && user.isAdmin"></thr-full-data-appropriateness-table>

                                <div class="row justify-content-end">
                                    <ng-container *ngIf="!user || !user.isAdmin">
                                        <div class="col-12 col-sm-6 col-md-4 mt-5">
                                            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormFullDataAccountValid">
                                                {{ 'general.save'|translate }}
                                            </button>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="user && user.isAdmin">
                                        <div class="col-12 col-sm-6 col-md-4 mt-5">
                                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!canRevise" (click)="onRevise()">
                                                {{ 'general.revise'|translate }}
                                            </button>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-5">
                                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!canValidate" (click)="onValidate()">
                                                {{ 'general.validate'|translate }}
                                            </button>
                                        </div>
                                    </ng-container>
                                </div>
                            </form>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</main>